import { DisplayInfo } from 'components/displayInfo/displayInfo';
import { DisplayStateName } from 'components/displayStateName/displayStateName';
import { DisplayCountryName } from 'components/displayCountryName/displayCountryName';

import template from './displayContactAndDelivery.html';
import './displayContactAndDelivery.scss';

export const DisplayContactAndDelivery = angular
    .module('checkout.components.displayContactAndDelivery', [
        DisplayInfo,
        DisplayStateName,
        DisplayCountryName
    ]).component('displayContactAndDelivery', {
        template,
        bindings: {
            cart: '<',
            isShippingRequired: '<',
            isShippingAddressVerified: '<',
            isBillingAddressVerified: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/displayContactAndDelivery/displayContactAndDelivery.js